var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudyAbroad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "url(#paint0_linear_1246_6021)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.5L10.8333 17.5L14.1667 19.3167V24.3167L20 27.5L25.8333 24.3167V19.3167L27.5 18.4083V24.1667H29.1667V17.5L20 12.5ZM24.1667 23.325L20 25.6L15.8333 23.325V20.225L20 22.5L24.1667 20.225V23.325ZM20 20.6L14.3167 17.5L20 14.4L25.6833 17.5L20 20.6Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1246_6021",
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyAbroad);
export default __webpack_public_path__ + "static/media/studyAbroad.4eb06f171cf939be9e3116aacc207846.svg";
export { ForwardRef as ReactComponent };